<template>
  <div>
    <div class="container-fluid m-0 p-0">
      <div class="row justify-content-center">
        <div class="col-md-7 t-center pt-5">
          <h1></h1>
        </div>
      </div>

      <div class="row bg-white pt-5 pb-5 ms-5 border-bottom">
        <div class="col-md-1 p-0 t-center">Kapitel</div>
        <div class="col-md-1 p-0 t-center">PDF</div>
        <div class="col-md-3 p-0 t-center">Bezeichnung</div>
        <div class="col-md-2 p-0 t-center">Quiz</div>
        <div class="col-md-3 p-0 t-center">Link</div>
      </div>

      <div class="row ms-5" v-for="i in 30" :key="i">
        <div class="col-md-1 p-0 t-center">{{ i }}</div>
        <div class="col-md-1 p-0 t-center">
          <a :href="`/PDF/${$data['PDF' + i]}`" download v-if="$data['PDF' + i]">
            <button class="btn btn-success p-1 m-1" style="min-width: 100px">
              PDF {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-3 p-0 t-center">
          {{ $data["Titel" + i] }}
        </div>

        <div class="col-md-2 p-0 t-center">
          <a :href="$data['Link' + i]" target="_blank" v-if="$data['Link' + i]">
            <button class="btn btn-primary p-1 m-1" style="min-width: 160px">
              Zum Quiz {{ i }}
            </button>
          </a>
        </div>

        <div class="col-md-5 p-0 t-center">
          {{ $data["Link" + i] }}
        </div>
      </div>
      <h2 class="ps-5 pt"> Ergänzungen</h2>
      <div class="row ms-5" v-for="i in 30" :key="i">
          <div class="col-md-1 p-0 t-center"></div>
          <div class="col-md-1 p-0 t-center">
            <a :href="`/PDF/${$data['PDF_sonstige' + i]}`" download v-if="$data['PDF_sonstige' + i]">
              <button class="btn btn-secondary p-1 m-1" style="min-width: 100px">
                PDF Sonstige {{ i }}
              </button>
            </a>
          </div>
          <div class="col-md-3 p-0 t-center">
            {{ $data["PDF_sonstige" + i] }}
          </div>
  
          <div class="col-md-2 p-0 t-center"></div>
  
          <div class="col-md-5 p-0 t-center"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImpressumPage",

  data() {
    return {
      newSite: null,
      Titel1: "Sprechen Sie Computer?",
      Titel2: "-",
      Titel3: "Vom Bit bis zum Personal Computer",
      Titel4: "Einblick in die Systemarchitektur",
      Titel5: "Externe Schnittstellen",
      Titel6: "Interne und externe Geräte",
      Titel7: "Ein- und Ausgabegeräte",
      Titel8: "Drucker",
      Titel9: "Grundlegende Betriebskonzepte",
      Titel10: "Ein Computersystem aufrüsten",
      Titel11: "Mobile Systeme erweitern",
      Titel12: "Unterhalt von Druckern",
      Titel13: "Mobile Systeme unterhalten und reparieren",
      Titel14: "Aus die Maus — was NUM?",
      Titel15: "Häh? — Kommunikation im Support",
      Titel16: "Einführung in die Welt der Netzwerke",
      Titel17: "Netzwerkprotokolle und -dienste",
      Titel18: "Netzwerke einrichten",
      Titel19: "Netzwerkunterhalt und Fehlersuche",
      Titel20: "Was betreibt ein Betriebssystem?",
      Titel21: "Die Installation von Windows",
      Titel22: "Die Konfiguration von Windows",
      Titel23: "Die Konfiguration von Windows 11",
      Titel24: "Unterhalt und Wartung für Windows",
      Titel25: "Installation und Konfiguration von macOS",
      Titel26: "Installation und Konfiguration von LinuX",
      Titel27: "Die Welt ist böse",
      Titel28: "Sicherheitsmaßnahmen ergreifen",
      Titel29: "So schützen Sie Ihre Systeme",
      Titel30: "Datenschutz und Datensicherheit",
      Link1: "https://forms.cloud.microsoft/e/iv3mNYbR6M?origin=lprLink",
      Link2: "",
      Link3: "https://forms.cloud.microsoft/e/gCD9ef5grV?origin=lprLink",
      Link4: "https://forms.cloud.microsoft/e/vciJ2G4F1L?origin=lprLink",
      Link5: "https://forms.cloud.microsoft/e/vgtRUbHDyQ?origin=lprLink",
      Link6: "https://forms.cloud.microsoft/e/wd9jkg7GQM?origin=lprLink",
      Link7: "https://forms.cloud.microsoft/e/hNzfJDWkaa?origin=lprLink",
      Link8: "https://forms.cloud.microsoft/e/DvbYVSUYXA?origin=lprLink",
      Link9: "https://forms.cloud.microsoft/e/G4TBT0Y0Ku?origin=lprLink",
      Link10: "https://forms.cloud.microsoft/e/YkBteCBcth?origin=lprLink",
      Link11: "https://forms.cloud.microsoft/e/E4iVvVg2YV?origin=lprLink",
      Link12: "https://forms.cloud.microsoft/e/yFZhShSefK?origin=lprLink",
      Link13: "https://forms.cloud.microsoft/e/z5THRSSmbS?origin=lprLink",
      Link14: "https://forms.cloud.microsoft/e/s4pBDy9jZ2?origin=lprLink",
      Link15: "https://forms.cloud.microsoft/e/NqKGjpHcR1?origin=lprLink",
      Link16: "https://forms.cloud.microsoft/e/DwEMQ1zLFH?origin=lprLink",
      Link17: "https://forms.cloud.microsoft/e/FFTYLjMe0S?origin=lprLink",
      Link18: "https://forms.cloud.microsoft/e/1Jx59fQjxq?origin=lprLink",
      Link19: "https://forms.cloud.microsoft/e/5C7a6xmjLR?origin=lprLink",
      Link20: "https://forms.cloud.microsoft/e/9YsHs1Ld82?origin=lprLink",
      Link21: "https://forms.cloud.microsoft/e/090UTZHiLY?origin=lprLink",
      Link22: "https://forms.cloud.microsoft/e/ApF0rJgpKc?origin=lprLink",
      Link23: "https://forms.cloud.microsoft/e/DT8zSD9464?origin=lprLink",
      Link24: "https://forms.cloud.microsoft/e/y0mLbmxGJY?origin=lprLink",
      Link25: "https://forms.cloud.microsoft/e/rPnSVRWVrA?origin=lprLink",
      Link26: "https://forms.cloud.microsoft/e/S42uWDeTmY?origin=lprLink",
      Link27: "https://forms.cloud.microsoft/e/ZQaqzjxv9y?origin=lprLink",
      Link28: "https://forms.cloud.microsoft/e/sb4Pgrs1CH?origin=lprLink",
      Link29: "https://forms.cloud.microsoft/e/enpEN3LRLi?origin=lprLink",
      Link30: "https://forms.cloud.microsoft/e/YXcJkd8Zs5?origin=lprLink",
      PDF1: "",
      PDF2: "",
      PDF3: "",
      PDF4: "",
      PDF5: "5 - Externe Schnittstellen.pdf",
      PDF6: "6 - Speichermedien.pdf",
      PDF7: "7 - Ein und Ausgabegeräte.pdf",
      PDF8: "8 - Drucker.pdf",
      PDF9: "9 - Grundlegende Betriebskonzepte.pdf",
      PDF10: "10 - Computer aufrüsten.pdf",
      PDF11: "11 - Mobile Systeme erweitern.pdf",
      PDF12: "12 - Unterhalt von Druckern.pdf",
      PDF13: "13 – Mobile Systeme.pdf",
      PDF14: "14 – Fehlerdiagnose.pdf",
      PDF15: "15 - Support.pdf",
      PDF16: "16 - Netzwerke.pdf",
      PDF17: "17 - Netzwerkprotokolle.pdf",
      PDF18: "18 - Netzwerke Einrichten.pdf",
      PDF19: "19 - Netzwerkunterhalt Fehlersuche.pdf",
      PDF20: "20 - Was betreibt ein Betriebssystem.pdf",
      PDF21: "21 - Die Installation von Windows.pdf",
      PDF22: "22 - Konfiguration Windows 10.pdf",
      PDF23: "23 - Konfiguration Windows 11.pdf",
      PDF24: "24 - Unterhalt und Wartung für Windows.pdf",
      PDF25: "25 - macOS_Installation.pdf",
      PDF26: "26 - Linux.pdf",
      PDF27: "27 - IT_Sicherheit_Grundlagen.pdf",
      PDF28: "28 - Sicherheitsmassnahmen.pdf",
      PDF29: "29 - Systemschutz.pdf",
      PDF30: "30 - Datensicherung.pdf",

      PDF_sonstige1: "17 - x  - IP_Klassen_A-D.pdf",
      PDF_sonstige2: "17 - x - DHCP_DORA_Grundlagen.pdf",
      PDF_sonstige3: "17 - x - DNS_Ablauf.pdf",
      PDF_sonstige4: "HTTP3_Troubleshooting.pdf",
      PDF_sonstige5: "Linux_Befehle_Vollstaendig.pdf",
      PDF_sonstige6: "RAID_Gesamtübersicht.pdf",
      PDF_sonstige7: "26a - Linux_Befehle_Vollstaendig.pdf",
      PDF_sonstige8: "",
      PDF_sonstige9: "",
      PDF_sonstige10: "",
      PDF_sonstige11: "",
      PDF_sonstige12: "",
      PDF_sonstige13: "",
      PDF_sonstige14: "",
      PDF_sonstige15: "",
      PDF_sonstige16: "",
      PDF_sonstige17: "",
      PDF_sonstige18: "",
      PDF_sonstige19: "",
      PDF_sonstige20: "",
      

    };
  },
  components: {},
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
